export default __webpack_public_path__ + "static/media/riak.e371627d.svg";